// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"085f6718","501":"99927b1e"}[chunkId] + ".chunk.js";
};